import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function CareerDetails1() {
  return (
    <>
      <Header />

      <section className="container" style={{ paddingTop: "120px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
          }}
        >
          <div
            style={{
              width: "300px",
              height: "1px",
              backgroundColor: "#dcdcdc",
            }}
          ></div>

       <p style={{ margin: 0, fontSize: "16px", color: "#888" }}>
        <Link to="/" style={{ color: "#111", textDecoration: "none", fontWeight: 600 }}>Home</Link>
        {" / "}
        <Link to="/careers" style={{ color: "#111", textDecoration: "none", fontWeight: 600 }}>Careers</Link>
        {" / "}
        Digital Marketing Executive Intern
        </p>
        </div>

        <h1
          style={{
            textAlign: "center",
            fontSize: "72px",
            lineHeight: "1.1",
            marginBottom: "80px",
          }}
        >
          <span style={{ fontWeight: "600" }}>
            Digital Marketing
          </span>

           <br />

          <span style={{ fontWeight: "300" }}>
            Executive Intern
          </span>
        </h1>

        <div style={{ maxWidth: "760px", margin: "0 auto" }}>

          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            <strong>Position:</strong> Digital Marketing Executive Intern
          </p>

          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            <strong>Job ID:</strong> BNWJB20260135
          </p>

          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            <strong>Employment Type:</strong> Internship (Remote)
          </p>

          <p style={{ marginBottom: "40px", fontSize: "18px" }}>
            <strong>Experience:</strong> Freshers
          </p>

          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "25px",
            }}
          >
            BlackWhite Creative Services is looking for a passionate and driven
            Digital Marketing Executive Intern to join our creative team. This role
            is ideal for individuals who are eager to learn, experiment, and grow
            in a fast-paced creative environment. As an intern, you will assist in
            planning, executing, and optimizing digital marketing campaigns across
            multiple platforms.
          </p>

          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "40px",
            }}
          >
            Your responsibilities will include managing social media accounts,
            creating engaging content, supporting paid ad campaigns, and analyzing
            performance metrics. You will collaborate closely with designers,
            content creators, and strategists to ensure consistent brand
            communication and impactful campaigns. You will also gain hands-on
            experience with tools for SEO, social media analytics, email marketing,
            and campaign reporting.
          </p>

          <h4 style={{ marginBottom: "25px" }}>
            Key Responsibilities:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "18px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Assist in planning and executing digital marketing campaigns</li>
            <li>Manage and schedule content across social media platforms</li>
            <li>Support content creation including captions, blogs, and creatives</li>
            <li>Monitor campaign performance and generate reports</li>
            <li>Conduct basic SEO research and optimization</li>
            <li>Stay updated with digital trends and suggest new ideas</li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Qualifications & Requirements:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "18px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Pursuing or recently completed a degree in Marketing, Business, Communications, or related field</li>
            <li>Strong interest in digital marketing and branding</li>
            <li>Basic understanding of social media platforms</li>
            <li>Familiarity with tools like Google Analytics, Meta Ads Manager, or similar is a plus</li>
            <li>Good written and verbal communication skills</li>
            <li>Creative thinking with attention to detail</li>
            <li>Ability to manage time and handle multiple tasks</li>
            <li>Basic knowledge of Canva, Adobe tools, or content creation tools is an advantage</li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            What You'll Gain:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "18px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Hands-on industry experience</li>
            <li>Exposure to real client projects</li>
            <li>Mentorship from experienced professionals</li>
            <li>Experience Letter and Letter of Recommendation based on performance</li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Internship Details:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "18px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Work Mode: Remote</li>
            <li>Duration: 6 Months</li>
            <li>Working Hours: Flexible schedule with expected commitment of 20–25 hours per week</li>
            <li>Immediate and follow-up opportunities during working days preferred</li>
            <li>
              Stipend: Optional. This internship is designed as a learning-focused
              opportunity offering hands-on industry exposure, mentorship, and
              real-world business development experience
            </li>
          </ul>


<p
  style={{
    fontSize: "18px",
    lineHeight: "1.8",
    color: "#777",
    marginBottom: "40px",
  }}
>
  This is your opportunity to step into the world of digital marketing
  and build a strong foundation for your career.
</p>

<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

</div>



      </section>

      <Footer />
    </>
  );
}

export default CareerDetails1;